var ChildStatusView = require('childstatusview');


var ConversationStatusView = ChildStatusView.extend({
    events: $.extend({}, ChildStatusView.prototype.events, {
        'buttonClick button.nickserv': 'clickNickserv',
        'buttonClick button.unarchive': 'clickUnarchive',
        'buttonClick button.archive': 'clickArchive',
        'buttonClick button.whois': 'clickWhois'
    }),
    clickNickserv: function (e) {
        this.model.connection.trigger('nickServPrompt', this.model.connection);
        return false;
    },
    clickUnarchive: function (e) {
        this.model.unarchive();
        return false;
    },
    clickArchive: function (e) {
        this.model.archive();
        return false;
    },
    clickWhois: function (e) {
        this.model.getRecipient().whois();
        return false;
    },
    render: function () {
        ChildStatusView.prototype.render.apply(this, arguments);
        this.avatar = $('<span class="conversation__avatar avatars-on">');
        this.realname = $('<span class="realname">');
        this.hostmask = $('<span class="hostmask">');
        this.ignored = $('<p class="conversation__ignored userInfo">');
        this.account = $('<span class="account">');
        this.awayMarker = $('<span class="away">');
        this.accountAway = $('<p class="conversation__account-away">');
        this.accountAway.append(this.account);
        this.accountAway.append(' ');
        this.accountAway.append(this.awayMarker);
        this.renderAvatar();
        this.renderRealname();
        this.renderHostmask();
        this.renderIgnored();
        this.renderAccountAway();
        this.avatar.insertBefore(this.title);
        this.title.append(' ');
        this.title.append(this.realname);
        this.title.append(' ');
        this.title.append(this.hostmask);
        this.title.append(this.accountAway);
        this.title.append(this.ignored);
        this.model.recipient.bind('change:away', this.renderAccountAway, this);
        this.model.recipient.bind('change:account', this.renderAccountAway, this);
        this.model.recipient.bind('change:realname', this.renderRealname, this);
        this.model.recipient.bind('change:nick', this.renderIgnored, this);
        this.model.recipient.bind('change:user', this.renderHostmask, this);
        this.model.recipient.bind('change:user', this.renderIgnored, this);
        this.model.recipient.bind('change:userhost', this.renderIgnored, this);
        this.model.recipient.bind('change:userhost', this.renderHostmask, this);
        this.model.recipient.bind('change:ident_prefix', this.renderIgnored, this);
        this.model.recipient.bind('change:ident_prefix', this.renderHostmask, this);
        this.listenTo(this.model.connection, 'ignoresChange', this.renderIgnored);
        this.model.recipient.bind('change:nick change:display_name', this.renderLabel, this);
        this.model.recipient.bind('change:realname change:avatar change:avatar_url', this.renderAvatar, this);
        this.listenTo(this.model, 'prefChange:avatars-off', this.renderAvatar);
        this.listenTo(this.model, 'prefChange:avatars-image-off', this.renderAvatar);
        this.listenTo(this.model, 'prefChange:inlineimages', this.renderAvatar);

        return this;
    },
    renderAvatarExternal: function () {
        var external = this.model.embedExternalAvatars();
        this.$el.toggleClass('avatars-external', !!external);
        this.$el.toggleClass('avatars-noexternal', !external);
    },
    renderAvatar: function () {
        this.renderAvatarExternal();
        var img = '';
        if (this.model.avatarsEnabled()) {
            var external = false;
            var avatar;
            if (this.model.imageAvatarsEnabled()) {
                avatar = this.model.recipient.getAvatar();
                if (!avatar) {
                    var lastIndex = this.model.messages.findLastIndex(function (m) {
                        return !m.isSelf() && m.isImportant();
                    });
                    if (lastIndex !== -1) {
                        avatar = this.model.messages.at(lastIndex).getAvatar();
                    }
                }
                if (avatar) {
                    external = avatar.external;
                    img += this.formatter.imageAvatar(avatar.src, this.model.isSelf(), {
                        size: 32,
                        external: external
                    });
                }
            }

            img += this.formatter.avatar(this.model.recipient.getName(), this.model.isSelf(), {
                fallback: !!avatar,
                name: this.model.recipient.getDisplayAuthor(),
                external: external
            });
        }
        this.avatar.html(img);
    },
    renderLabel: function () {
        var label;
        if (this.model.connection.isSlack()) {
            var url = this.model.getSlackUrl();
            label = this.formatter.linker.makeLinkFromUrl(url, this.formatter.escapeText(this.model.getDisplayName()));
            label = 'Direct message with ' + label;
        } else {
            label = this.formatter.render(this.model.getTitle());
        }
        this.label.html(label);
    },
    renderButtons: function () {
        ChildStatusView.prototype.renderButtons.apply(this);
        if (this.model.isNickserv()) {
            this.appendButton('nickserv', 'Identify Nickname');
        }
        this.appendButton('unarchive', 'Unarchive');
        this.appendButton('archive', 'Archive');
        this.appendButton('whois', 'Whois');
        
        this.appendOptionsButton();
    },
    renderAccountAway: function () {
        this.renderAway();
        this.renderAccount();
        var show = !!(this.model.getAway() || this.model.getAccount());
        this.accountAway.toggleClass('conversation__account-away--show', show);
        this.trigger('topChange');
    },
    renderAway: function () {
        if (this.model.isAway()) {
            var away = this.model.getAway();
            var msg = 'away';
            if (away !== true) {
                msg += ': ' + away;
            }
            this.$el.addClass('away');
            this.awayMarker.html(this.formatter.render(msg));
        } else {
            this.$el.removeClass('away');
            this.awayMarker.empty();
        }
        return this;
    },
    renderIgnored: function () {
        var ignored = this.model.isIgnored({returnMap: true});
        this.ignored.toggleClass('conversation__ignored--undo', !ignored.match);
        if (ignored.match) {
            this.ignored.addClass('conversation__ignored--show');
            var unignore = $('<button class="conversation__ignored-button conversation__ignored-unignore">').append('<span>unignore</span>').on('click', _.bind(function (e) {
                e.preventDefault();
                _.each(ignored.masks, function (m) {
                    this.model.connection.unignore(m);
                }, this);
            }, this));
            var undo = $('<button class="conversation__ignored-button conversation__ignored-undounignore">').append('<span>undo</span>').on('click', _.bind(function (e) {
                e.preventDefault();
                this.model.connection.ignore(ignored.masks[0]);
            }, this));
            var dismiss = $('<button class="conversation__ignored-button conversation__ignored-dismiss">').append('<span>dismiss</span>').on('click', _.bind(function (e) {
                e.preventDefault();
                this.ignored.empty().removeClass('conversation__ignored--show');
            }, this));
            this.ignored.empty()
                .append(unignore)
                .append(undo)
                .append(dismiss)
                .append('Ignoring: <b>' + this.formatter.escapeText(ignored.masks[0]) + '</b> ')
                .append($('<span class="explanation">').text('This hides channel messages and prevents private message notifications. Archive to hide completely.'));
        }
    },
    renderHostmask: function () {
        this.hostmask.toggle(this.model.connection.hasMeaningfulHostnames());
        var mask = this.model.recipient.getHostMask();
        if (mask) {
            this.hostmask.html('(' + this.formatter.renderNoEmoji(mask) + ')');
        } else {
            this.hostmask.empty();
        }
    },
    renderRealname: function () {
        var realname = this.model.recipient.getRealname();
        if (realname) {
            this.realname.html(this.formatter.renderLinkify(realname));
        } else {
            this.realname.empty();
        }
    },
    renderAccount: function () {
        var account = this.model.getAccount();
        if (account) {
            this.$el.addClass('authed');
            this.account.html('Logged in as: <b>' + this.formatter.renderLinkify(account) + '</b>');
        } else {
            this.$el.removeClass('authed');
            this.account.empty();
        }
    },
});


module.exports = ConversationStatusView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/conversationstatusview.js
// module id = mysc
// module chunks = 1